export default function splitTitle(title: string): {
  position: string;
  company: string;
} {
  const lastCommaIndex = title.lastIndexOf(",");

  if (lastCommaIndex !== -1) {
    const position = title.substring(0, lastCommaIndex).trim();
    const company = title.substring(lastCommaIndex + 1).trim();

    return { position, company };
  }

  // If there's no comma, consider the entire string as the position and an empty string for the company.
  return { position: title.trim(), company: "" };
}
